import type { ColorPickerEventPayload } from '@components/sp-color-picker/src/types/color-picker.type';

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ThemeStateService } from '@sites/site-theme/src/state';

import { SpColorPickerV2Component } from '@components/sp-color-picker/src/v2/sp-color-picker-v2.component';

@Component({
    selector: 'web-color-picker-v2',
    templateUrl: './web-color-picker-v2.component.html',
    styleUrls: ['./web-color-picker-v2.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SpColorPickerV2Component],
})
export class WebColorPickerV2Component {
    private readonly themeState = inject(ThemeStateService);

    @Input() public color!: string;
    @Input() public ariaLabel = 'Color';
    @Input() public positionLeft = false;
    @Input() public hideGradient = false;

    @Output() public colorChangeEvent = new EventEmitter<ColorPickerEventPayload>();

    public readonly selectedThemeColors = this.themeState.selectedColors;
}
